import { render } from "./MyMemberLegBox.vue?vue&type=template&id=75ce4872"
import script from "./MyMemberLegBox.vue?vue&type=script&lang=js"
export * from "./MyMemberLegBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__